import { render, staticRenderFns } from "./BuyPoint.vue?vue&type=template&id=f2a77b9c&scoped=true&"
import script from "./BuyPoint.vue?vue&type=script&lang=js&"
export * from "./BuyPoint.vue?vue&type=script&lang=js&"
import style0 from "./BuyPoint.vue?vue&type=style&index=0&id=f2a77b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a77b9c",
  null
  
)

export default component.exports